const LeftArrow = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 85" {...props}>
    <path
      fill="currentColor"
      d="M0 34.758v15.484L34.59 85H50V69.516L23.115 42.5 50 15.484V0H34.59Zm36.598 45.484L6.662 50.161l.43-.005 6.858.071 29.79 29.935Zm8.667-8.71-.08 7.177-29.053-29.193 3.612-3.628Zm0-58.065L19.744 39.113l-3.612-3.63L45.185 6.292ZM43.74 4.838 13.95 34.773l-6.859.07-.43-.004L36.598 4.758Z"
    />
  </svg>
);
export default LeftArrow;
